"use client";

import React from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
const partners = [{
  id: 1,
  name: "Global Logistics Corp",
  role: "Strategic Supply Chain Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/logo_global_logistics.png"
}, {
  id: 2,
  name: "Apex Infrastructure",
  role: "Construction Management Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/logo_apex_infra.png"
}, {
  id: 3,
  name: "Horizon Tech Solutions",
  role: "Digital Transformation Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/logo_horizon_tech.png"
}, {
  id: 4,
  name: "Maritime Alliance",
  role: "International Freight Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/logo_maritime_alliance.png"
}, {
  id: 5,
  name: "Summit Resource Group",
  role: "Human Capital Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/logo_summit_resources.png"
}, {
  id: 6,
  name: "EuroLink Transit",
  role: "Cross-Border Logistics Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/logo_eurolink_transit.png"
}, {
  id: 7,
  name: "Pacific Trade Hub",
  role: "Global Commerce Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/logo_pacific_trade.png"
}, {
  id: 8,
  name: "Nova Analytics",
  role: "Data & Insights Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/logo_nova_analytics.png"
}];
export default function OurTrustedPartners() {
  const marqueeItems = [...partners, ...partners];
  return <section data-section-id="224102" id="our-partners" className="bg-background text-foreground py-16 md:py-24 overflow-hidden border-y border-border/30">
      <style>{`
        @keyframes marquee-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee-scroll {
          animation: marquee-scroll 40s linear infinite;
        }
      `}</style>

      <div className="container mx-auto px-4 md:px-6 mb-10">
        <h2 className="text-center text-sm md:text-base font-default font-bold tracking-widest uppercase text-secondary">
          Global Strategic Network
        </h2>
      </div>

      <div className="relative flex overflow-hidden group w-full">
        {}
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 md:w-32 bg-gradient-to-r from-background to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 md:w-32 bg-gradient-to-l from-background to-transparent" />

        <div className="flex w-max animate-marquee-scroll group-hover:[animation-play-state:paused] items-center gap-12 md:gap-24 px-6 md:px-12">
          {marqueeItems.map((partner, i) => <div data-index={i} key={`${partner.id}-${i}`} className="flex-shrink-0">
              <Tooltip>
                <TooltipTrigger asChild>
                  <div className="flex items-center justify-center h-20 w-32 md:w-48 cursor-help transition-transform duration-300 hover:scale-110">
                    <img src={partner.logo} alt={`${partner.name} logo`} className="max-h-12 md:max-h-16 w-auto object-contain grayscale opacity-50 transition-all duration-500 ease-in-out hover:grayscale-0 hover:opacity-100 brightness-100 dark:brightness-200" loading="lazy" />
                  </div>
                </TooltipTrigger>
                <TooltipContent side="bottom" className="font-default bg-card border-border shadow-xl">
                  <p className="font-semibold text-sm text-foreground">{partner.name}</p>
                  <p className="text-xs text-primary font-mono">
                    {partner.role}
                  </p>
                </TooltipContent>
              </Tooltip>
            </div>)}
        </div>
      </div>
    </section>;
}